import {useStore} from "vuex";
import {computed} from "vue";

export default function UseEditElement() {

  const store = useStore()


  const editElement = (elementForm) => {
    return store.dispatch('elements/editElement', elementForm)
  }

  return {
    elementData: computed(() => store.getters['elements/getSelectedElementData']),
    isEditElementLoading: computed(() => store.state.elements.loadStatuses.isEditElementLoading),
    errors: computed(() => store.state.elements.errors),
    clearValueError: () => store.commit('elements/setErrors', {value: undefined}),
    editElement,
  }
}
